module.exports = __webpack_public_path__ + "static/bhaal_game_bg3-2bcf7d8eb26585f8c2412c155034ccb2.webp";